import React, { useState } from "react";
import styled from "styled-components";
import { Btns, ButtonL, ImgWrap, InputsDiv } from "../../styles/Common";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../modal/Modal";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../hooks/useDidMountEffect";
import { userActions } from "../../store/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { getToken } from "../hooks/authFunc";

const Inquiry = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = getToken();
  const modalMsg = useSelector((state) => state.user.modalMsg);
  const inquiryAddSuccess = useSelector(
    (state) => state.user.inquiryAddSuccess
  );
  const [openModal, setOpenModal] = useState(false);
  const [myInquiry, setMyInquiry] = useState({
    category: 1,
    title: "",
    content: "",
  });

  const addInquiry = () => {
    if (myInquiry.title == "") {
      dispatch(
        userActions.showMsg({
          type: "",
          msg: `문의하기 제목을 입력해주세요.`,
        })
      );
      return;
    }
    if (myInquiry.content == "") {
      dispatch(
        userActions.showMsg({
          type: "",
          msg: `문의하기 내용을 입력해주세요.`,
        })
      );
      return;
    }

    const params = myInquiry;
    dispatch(userActions.fetchInquiryAdd({ params, accessToken }));
  };

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  return (
    <InquiryWrap>
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          callbackFunc={
            inquiryAddSuccess
              ? () => {
                  props.clickTab(0);
                }
              : () => {
                  return;
                }
          }
        >
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <InputsDiv>
        <div>
          <h3>문의유형</h3>
          <select
            className="pointer"
            onChange={(e) => {
              setMyInquiry((prev) => ({
                ...prev,
                category: Number(e.target.value),
              }));
            }}
          >
            <option value={1}>회원가입/탈퇴</option>
            <option value={2}>포인트</option>
            <option value={3}>월렛</option>
            <option value={4}>스왑</option>
            <option value={5}>AMO 코인</option>
            <option value={6}>기타</option>
          </select>
        </div>
        <div>
          <h3>제목</h3>
          <input
            type="text"
            placeholder="제목을 입력해주세요."
            name="title"
            value={myInquiry.title}
            onChange={(e) => {
              setMyInquiry((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }));
            }}
          />
        </div>
        <div>
          <h3>내용</h3>
          <input
            type="text"
            placeholder="내용을 입력해주세요."
            name="content"
            value={myInquiry.content}
            onChange={(e) => {
              setMyInquiry((prev) => ({
                ...prev,
                [e.target.name]: e.target.value,
              }));
            }}
          />
        </div>
      </InputsDiv>
      <InquiryBtns>
        <ButtonL onClick={addInquiry}>등록</ButtonL>
      </InquiryBtns>
    </InquiryWrap>
  );
};

export default Inquiry;
const InquiryWrap = styled.div`
  padding-top: 3rem;
  height: calc(100vh - 14.6rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  select {
    width: 100%;
    background-color: transparent;
    width: 100%;
    height: 3.4rem;
    line-height: 3.4rem;
    border-bottom: 1px solid #000;
    color: ${({ theme }) => theme.color.black};
    font-family: NanumSquareR;
    font-size: 1.6rem;
    &:focus {
      outline: 0;
    }
  }
`;
const InquiryBtns = styled(Btns)`
  padding: 0;
  padding-bottom: 1.6rem;
`;
